import React from 'react';
import { Facebook, Instagram, Mail, Phone, MapPin } from 'lucide-react';
export function WomensSelfDefenseFooter() {
  return <footer className="bg-black text-white pt-16 pb-8 border-t border-gray-900" data-id="element-2030">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-2031">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-12 mb-12" data-id="element-2032">
          <div data-id="element-2033">
            <div className="flex items-center gap-3 mb-6" data-id="element-2034">
              <div className="relative w-10 h-10 overflow-hidden rounded-full border border-[#00D4FF] bg-black" data-id="element-2035">
                <img src="https://cdn.magicpatterns.com/uploads/fmBXjQm2BPtC5bTSRKvwCz/walkerlogo-gigapixel-cgi-3600w.png" alt="Walker's Martial Arts Logo" className="w-full h-full object-cover" data-id="element-2036" />
              </div>
              <div className="flex flex-col" data-id="element-2037">
                <span className="text-white font-bold text-base leading-none tracking-wide uppercase" data-id="element-2038">
                  Walker's
                </span>
                <span className="text-[#00D4FF] font-bold text-xs leading-none tracking-wider uppercase" data-id="element-2039">
                  Martial Arts
                </span>
              </div>
            </div>
            <p className="text-gray-400 mb-6 max-w-xs" data-id="element-2040">
              "Where Families Kick Together"
              <br data-id="element-2041" />
              Proudly serving the Bloomington community and surrounding area
              since 1999.
            </p>
            <div className="flex gap-4" data-id="element-2042">
              <a href="#" className="w-10 h-10 rounded-full bg-gray-900 flex items-center justify-center text-gray-400 hover:bg-[#00D4FF] hover:text-black transition-all" data-id="element-2043">
                <Facebook size={20} data-id="element-2044" />
              </a>
              <a href="#" className="w-10 h-10 rounded-full bg-gray-900 flex items-center justify-center text-gray-400 hover:bg-[#00D4FF] hover:text-black transition-all" data-id="element-2045">
                <Instagram size={20} data-id="element-2046" />
              </a>
            </div>
          </div>
          <div data-id="element-2047">
            <h4 className="text-lg font-bold text-white mb-6 uppercase tracking-wider" data-id="element-2048">
              Contact Us
            </h4>
            <ul className="space-y-4 text-gray-400" data-id="element-2049">
              <li className="flex items-start gap-3" data-id="element-2050">
                <MapPin className="w-5 h-5 text-[#00D4FF] shrink-0 mt-1" data-id="element-2051" />
                <span className="text-sm" data-id="element-2052">
                  1304 E. Empire Suite 2.
                  <br data-id="element-2053" />
                  Bloomington, Illinois 61701
                  <br data-id="element-2054" />
                  <span className="text-xs text-gray-500" data-id="element-2055">
                    (Inside the Regions Bank Complex at the intersection of
                    Empire & Towanda)
                  </span>
                </span>
              </li>
              <li className="flex items-center gap-3" data-id="element-2056">
                <Phone className="w-5 h-5 text-[#00D4FF] shrink-0" data-id="element-2057" />
                <a href="tel:3092422440" className="hover:text-white transition-colors" data-id="element-2058">
                  (309) 242-2440
                </a>
              </li>
              <li className="flex items-center gap-3" data-id="element-2059">
                <Mail className="w-5 h-5 text-[#00D4FF] shrink-0" data-id="element-2060" />
                <a href="mailto:walkerskicks@gmail.com" className="hover:text-white transition-colors" data-id="element-2061">
                  walkerskicks@gmail.com
                </a>
              </li>
            </ul>
          </div>
          <div data-id="element-2062">
            <h4 className="text-lg font-bold text-white mb-6 uppercase tracking-wider" data-id="element-2063">
              Class Hours
            </h4>
            <ul className="space-y-2 text-gray-400" data-id="element-2064">
              <li className="flex justify-between" data-id="element-2065">
                <span data-id="element-2066">Monday - Thursday</span>
                <span className="text-white" data-id="element-2067">5:00 AM - 9:00 PM</span>
              </li>
              <li className="flex justify-between" data-id="element-2068">
                <span data-id="element-2069">Friday</span>
                <span className="text-white" data-id="element-2070">5:00 AM - 7:00 PM</span>
              </li>
              <li className="flex justify-between" data-id="element-2071">
                <span data-id="element-2072">Saturday</span>
                <span className="text-white" data-id="element-2073">9:00 AM - 2:00 PM</span>
              </li>
              <li className="flex justify-between" data-id="element-2074">
                <span data-id="element-2075">Sunday</span>
                <span className="text-white" data-id="element-2076">8:00 AM - 12:00 PM</span>
              </li>
            </ul>
          </div>
        </div>
        <div className="border-t border-gray-900 pt-8 flex flex-col md:flex-row justify-between items-center gap-4 text-sm text-gray-500" data-id="element-2077">
          <p data-id="element-2078">
            &copy; {new Date().getFullYear()} Walker's Martial Arts. All rights
            reserved.
          </p>
          <div className="flex gap-6" data-id="element-2079">
            <a href="#" className="hover:text-white transition-colors" data-id="element-2080">
              Privacy Policy
            </a>
            <a href="#" className="hover:text-white transition-colors" data-id="element-2081">
              Terms of Service
            </a>
          </div>
        </div>
      </div>
    </footer>;
}